// LoadingWithMessages.jsx
import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import LoadingSpinner from '../spinner/LoadingSpinner';
import styles from './LoadingWithMessages.module.scss';

const LoadingWithMessages = ({
  messages = [],
  interval = 2000,
  showSpinner = true,
  className = '',
  messageClassName = '',
  spinnerClassName = ''
}) => {
  const [currentMessageIndex, setCurrentMessageIndex] = useState(0);

  // Default messages if none provided
  const defaultMessages = ['Loading...', 'Please wait while we prepare everything for you...', 'Almost there...', 'Just a moment more...'];

  const messagesToUse = messages.length > 0 ? messages : defaultMessages;

  useEffect(() => {
    if (messagesToUse.length <= 1) return;

    const messageInterval = setInterval(() => {
      setCurrentMessageIndex((prevIndex) => {
        const newIndex = (prevIndex + 1) % messagesToUse.length;
        return newIndex;
      });
    }, interval);

    return () => {
      clearInterval(messageInterval);
    };
  }, [messagesToUse.length, interval]);

  return (
    <div className={`${styles.loadingContainer} ${className}`}>
      {showSpinner && (
        <div className={spinnerClassName}>
          <LoadingSpinner />
        </div>
      )}
      <p className={`${styles.loadingMessage} ${messageClassName}`}>{messagesToUse[currentMessageIndex]}</p>
    </div>
  );
};

LoadingWithMessages.propTypes = {
  messages: PropTypes.arrayOf(PropTypes.string),
  interval: PropTypes.number,
  showSpinner: PropTypes.bool,
  className: PropTypes.string,
  messageClassName: PropTypes.string,
  spinnerClassName: PropTypes.string
};

export default LoadingWithMessages;
